import React from "react";
import BigError from "../Misc/BigError";
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <BigError title={"Критическая ошибка"} message={error.toString()} />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
